import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ManagedServicesRoutingModule } from './managed-services-routing.module';
import { GSOAMISAASComponent } from './gso-ami-saas/gso-ami-saas.component';
import { SharedModule } from 'app/shared/shared.module';
import { ResyncDialogComponent } from './gso-ami-saas/resync-dialog/resync-dialog.component';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    SharedModule,
    ManagedServicesRoutingModule,
    MatDialogModule,
    GSOAMISAASComponent,
    ResyncDialogComponent
  ]
})
export class ManagedServicesModule {}
